import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ImageComponent from '../../../../../../common/modules-react/gw-components-platform-react/ImageComponent/ImageComponent';
import styles from '../../../themes/SasriaTheme/Styles/SasriaEntryPageTemplate.module.scss';

function SasriaEntryPageTemplate(props) {
    const { applicationName, applicationLogo, contentToRender } = props;

    return (
        <Fragment>
            <div id="sasriaEntryPageTemplate" className={styles.sasriaEntryPageTemplate}>
                <div id="sasriaEntryPageTemplateHeader" className={styles.sasriaEntryPageTemplateHeader}>
                    
                    <h2
                        id="sasriaEntryPageTemplateApplicationName"
                        className={styles.sasriaEntryPageTemplateApplicationName}
                    >
                        {applicationName}
                    </h2>
                    <div id="sasriaEntryPageTemplateLogoMobile" className={styles.sasriaEntryPageTemplateLogoMobile}>
                        <ImageComponent src={applicationLogo} title={applicationName} />
                    </div>
                </div>
                
                <div id="sasriaEntryPageTemplateContent" className={styles.sasriaEntryPageTemplateContent}>
                
                    <div
                        id="sasriaEntryPageContentContainer"
                        className={styles.sasriaEntryPageContentContainer}
                    >
                        {contentToRender}
                    </div>
                </div>
                    <div id="sasriaEntryPageTemplateLogo" className={styles.sasriaEntryPageTemplateLogo}>
                        <ImageComponent src={applicationLogo} title={applicationName} />
                    </div>
            </div>
            <footer id="sasriaEntryPageFooter" className={styles.sasriaPageFooter}>
                <p className={styles.sasriaPageFooterText}>Sasria SOC Ltd is an authorised FSP registered under license number 39117</p>
            </footer>
        </Fragment>
    );
}

SasriaEntryPageTemplate.propTypes = {
    applicationName: PropTypes.string.isRequired,
    applicationLogo: PropTypes.string.isRequired,
    contentToRender: PropTypes.shape({}).isRequired
};

export default SasriaEntryPageTemplate;
